import { atom } from "recoil";

const usersState = atom({
  key: "usersState",
  default: null,
});

export default usersState;
